import { render, staticRenderFns } from "./PrintPosFacturaTicketV2.vue?vue&type=template&id=5a000002&scoped=true"
import script from "./PrintPosFacturaTicketV2.vue?vue&type=script&lang=js"
export * from "./PrintPosFacturaTicketV2.vue?vue&type=script&lang=js"
import style0 from "./PrintPosFacturaTicketV2.vue?vue&type=style&index=0&id=5a000002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a000002",
  null
  
)

export default component.exports